import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, apiScopes } from './msalConfig';

export function useAuth() {
  const { instance, accounts } = useMsal();
  const account = accounts[0] ?? null;

  const login = useCallback(async () => {
    await instance.loginRedirect(loginRequest);
  }, [instance]);

  const logout = useCallback(async () => {
    await instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  }, [instance]);

  const getToken = useCallback(async (): Promise<string> => {
    if (!account) throw new Error('No authenticated account');
    const result = await instance.acquireTokenSilent({
      scopes: apiScopes,
      account,
    });
    return result.accessToken;
  }, [instance, account]);

  return {
    account,
    isAuthenticated: account !== null,
    currentUser: account
      ? { name: account.name ?? '', email: account.username }
      : null,
    login,
    logout,
    getToken,
  };
}
